import { gql } from "@apollo/client";


const BOOKINGS_INSIGHTS_RESPONSE = gql`
    fragment bookingsInsightsResponse on BookingsInsightsResponse {
        total,
        bookedBookings,
        averageDuration,
        averageBookingsPerLocation
    }
`

const VEHICLES_INSIGHTS_RESPONSE = gql`
    fragment vehiclesInsightsResponse on VehiclesInsightsResponse {
        totalVehicles
        averageUtilization
        highestMileage
        averageMileage
        damagedVehicles,
        newVehicles
    }
`

const VEHICLE_UTILIZATION_RESPONSE = gql`
    fragment vehicleUtilizationResponse on VehicleUtilizationResponse {
        utilization
        vehicle {
            id
            displayName
            vin
            sourceVehicleId
        }
    }
`

export const GET_NEW_DASHBOARD = gql`
    ${BOOKINGS_INSIGHTS_RESPONSE}
    ${VEHICLES_INSIGHTS_RESPONSE}
    ${VEHICLE_UTILIZATION_RESPONSE}
    query NewDashboard(
      $annualStartDate: String!
      $reportStartDate: String!
      $reportEndDate: String!
      $stakeholderId: Int!
      $vehicleCenterIds: [Int!]!
      $months: Int!
    ) {
        annualDashboardData: dashboard(
          input: {
            reportStartDate: $annualStartDate
            reportEndDate: $reportEndDate
            stakeholderId: $stakeholderId
            vehicleCenterIds: $vehicleCenterIds
          }
        ) {
          annualBookingsInsight: bookingInsight {
            ...bookingsInsightsResponse
            approvedBookings
          }
      
          annualVehiclesInsight: vehiclesInsight {
              ...vehiclesInsightsResponse
          }
        }
        
        newDashboard: dashboard(
            input: {
              reportStartDate: $reportStartDate
              reportEndDate: $reportEndDate
              stakeholderId: $stakeholderId
              vehicleCenterIds: $vehicleCenterIds
            }
          ) {
            bookingInsight {
              ...bookingsInsightsResponse
              approvedBookings
            }
        
            vehiclesInsight {
                ...vehiclesInsightsResponse
            }

            monthlyVehiclesUtilizations(months: $months) {
              monthName
              utilization
            }
        
            topUtilizationVehicles(count: 5) {
              lowest {
                ...vehicleUtilizationResponse
              }
              highest {
                ...vehicleUtilizationResponse
              }
            }

            monthlyBookings (months: $months){
              year
              monthName
              total
            }
          }
      }
`